package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Norfolk Island Flag (20x15dp)
 *
 * - ISO Alpha-2: NF
 * - ISO Alpha-3: NFK
 * - ISO Numeric: 574
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.NorfolkIsland: ImageVector by lazy {
    ImageVector.Builder(
        name = "Norfolk Island:NF:NFK:574:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(14f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(6f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(14f)
                verticalLineTo(15f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.935f, 11.731f)
                curveTo(6.962f, 11.89f, 6.656f, 11.415f, 6.656f, 11.415f)
                lineTo(6.778f, 11.315f)
                curveTo(6.86f, 11.247f, 7.137f, 11.27f, 7.406f, 11.293f)
                curveTo(7.538f, 11.304f, 7.668f, 11.315f, 7.772f, 11.315f)
                curveTo(7.923f, 11.315f, 8.098f, 11.292f, 8.28f, 11.268f)
                curveTo(8.478f, 11.242f, 8.684f, 11.215f, 8.879f, 11.215f)
                curveTo(9.254f, 11.215f, 7.772f, 10.725f, 7.455f, 11.026f)
                curveTo(7.138f, 11.326f, 6.25f, 10.886f, 6.25f, 10.636f)
                curveTo(6.25f, 10.465f, 6.577f, 10.527f, 6.875f, 10.584f)
                curveTo(7.014f, 10.611f, 7.147f, 10.636f, 7.237f, 10.636f)
                curveTo(7.522f, 10.636f, 6.952f, 10.08f, 6.656f, 10.08f)
                curveTo(6.359f, 10.08f, 6.952f, 9.951f, 7.237f, 9.951f)
                curveTo(7.4f, 9.951f, 7.55f, 9.993f, 7.68f, 10.029f)
                lineTo(7.68f, 10.029f)
                curveTo(7.778f, 10.056f, 7.864f, 10.08f, 7.935f, 10.08f)
                curveTo(8.098f, 10.08f, 7.117f, 9.658f, 6.952f, 9.658f)
                horizontalLineTo(7.772f)
                curveTo(8.053f, 9.658f, 8.121f, 9.698f, 8.186f, 9.736f)
                curveTo(8.244f, 9.769f, 8.3f, 9.801f, 8.505f, 9.801f)
                curveTo(8.938f, 9.801f, 8.701f, 9.564f, 8.701f, 9.564f)
                curveTo(8.701f, 9.564f, 7.237f, 9.412f, 6.952f, 9.203f)
                curveTo(6.76f, 9.061f, 7.277f, 9.111f, 7.765f, 9.158f)
                curveTo(7.999f, 9.181f, 8.227f, 9.203f, 8.367f, 9.203f)
                curveTo(8.799f, 9.203f, 7.455f, 8.894f, 7.237f, 8.894f)
                horizontalLineTo(8.228f)
                curveTo(8.445f, 8.894f, 8.683f, 8.964f, 8.932f, 9.037f)
                lineTo(8.932f, 9.037f)
                curveTo(9.208f, 9.118f, 9.498f, 9.203f, 9.789f, 9.203f)
                curveTo(10.097f, 9.203f, 9.497f, 9.019f, 8.838f, 8.818f)
                curveTo(8.305f, 8.655f, 7.734f, 8.481f, 7.571f, 8.382f)
                curveTo(7.404f, 8.279f, 7.531f, 8.319f, 7.764f, 8.391f)
                curveTo(8.034f, 8.475f, 8.447f, 8.603f, 8.701f, 8.603f)
                curveTo(9.174f, 8.603f, 8.071f, 8.139f, 7.772f, 8.139f)
                curveTo(7.472f, 8.139f, 7.185f, 8.004f, 7.455f, 7.88f)
                curveTo(7.621f, 7.803f, 8.053f, 7.918f, 8.429f, 8.019f)
                lineTo(8.429f, 8.019f)
                curveTo(8.665f, 8.082f, 8.88f, 8.139f, 8.992f, 8.139f)
                curveTo(9.129f, 8.139f, 9.23f, 8.192f, 9.337f, 8.249f)
                curveTo(9.459f, 8.313f, 9.589f, 8.382f, 9.789f, 8.382f)
                curveTo(10.166f, 8.382f, 8.992f, 7.88f, 8.505f, 7.88f)
                curveTo(8.017f, 7.88f, 7.935f, 7.643f, 8.228f, 7.643f)
                curveTo(8.521f, 7.643f, 7.571f, 7.24f, 7.571f, 7.24f)
                curveTo(7.571f, 7.24f, 7.434f, 6.955f, 7.772f, 6.955f)
                horizontalLineTo(8.228f)
                curveTo(8.384f, 6.955f, 8.071f, 6.459f, 7.772f, 6.459f)
                curveTo(7.472f, 6.459f, 7.733f, 6.309f, 8.228f, 6.309f)
                curveTo(8.529f, 6.309f, 8.704f, 6.413f, 8.916f, 6.538f)
                curveTo(9.052f, 6.618f, 9.204f, 6.708f, 9.413f, 6.784f)
                curveTo(9.946f, 6.977f, 9.544f, 6.459f, 9.413f, 6.459f)
                curveTo(9.282f, 6.459f, 7.935f, 6.037f, 7.935f, 6.037f)
                curveTo(7.935f, 6.037f, 8.071f, 5.881f, 7.935f, 5.669f)
                curveTo(7.831f, 5.51f, 8.261f, 5.591f, 8.523f, 5.64f)
                lineTo(8.523f, 5.64f)
                curveTo(8.608f, 5.657f, 8.675f, 5.669f, 8.701f, 5.669f)
                curveTo(8.763f, 5.669f, 8.941f, 5.714f, 9.159f, 5.768f)
                lineTo(9.16f, 5.768f)
                curveTo(9.307f, 5.805f, 9.473f, 5.846f, 9.634f, 5.881f)
                curveTo(10.035f, 5.969f, 8.275f, 5.235f, 8.071f, 5.235f)
                curveTo(7.868f, 5.235f, 8.505f, 5.114f, 8.879f, 5.114f)
                curveTo(9.063f, 5.114f, 9.152f, 5.143f, 9.243f, 5.173f)
                curveTo(9.336f, 5.204f, 9.431f, 5.235f, 9.634f, 5.235f)
                curveTo(10.035f, 5.235f, 8.879f, 4.806f, 8.505f, 4.806f)
                curveTo(8.13f, 4.806f, 8.352f, 4.436f, 8.505f, 4.436f)
                curveTo(8.564f, 4.436f, 8.715f, 4.456f, 8.899f, 4.48f)
                lineTo(8.899f, 4.48f)
                curveTo(9.188f, 4.518f, 9.559f, 4.567f, 9.789f, 4.567f)
                curveTo(9.964f, 4.567f, 9.804f, 4.518f, 9.572f, 4.447f)
                curveTo(9.304f, 4.365f, 8.94f, 4.253f, 8.879f, 4.153f)
                curveTo(8.813f, 4.042f, 8.948f, 4.062f, 9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                lineTo(9.185f, 4.097f)
                curveTo(9.228f, 4.103f, 9.274f, 4.11f, 9.323f, 4.117f)
                curveTo(9.484f, 4.201f, 9.619f, 4.256f, 9.639f, 4.191f)
                curveTo(9.645f, 4.173f, 9.657f, 4.16f, 9.673f, 4.15f)
                curveTo(9.712f, 4.152f, 9.75f, 4.153f, 9.789f, 4.153f)
                curveTo(10.013f, 4.153f, 9.909f, 4.119f, 9.695f, 4.078f)
                lineTo(9.675f, 4.072f)
                curveTo(9.349f, 3.972f, 8.644f, 3.759f, 8.908f, 3.891f)
                curveTo(8.96f, 3.917f, 9.018f, 3.948f, 9.078f, 3.982f)
                curveTo(8.9f, 3.958f, 8.751f, 3.942f, 8.701f, 3.942f)
                curveTo(8.523f, 3.942f, 8.344f, 3.804f, 8.701f, 3.804f)
                horizontalLineTo(9.413f)
                curveTo(9.191f, 3.804f, 8.879f, 3.804f, 8.879f, 3.63f)
                curveTo(8.879f, 3.512f, 9.126f, 3.555f, 9.354f, 3.594f)
                curveTo(9.461f, 3.612f, 9.564f, 3.63f, 9.634f, 3.63f)
                curveTo(9.856f, 3.63f, 9.911f, 3.63f, 9.789f, 3.527f)
                curveTo(9.674f, 3.429f, 9.277f, 3.429f, 9.03f, 3.429f)
                horizontalLineTo(9.03f)
                lineTo(8.992f, 3.429f)
                curveTo(8.751f, 3.429f, 9.505f, 3.303f, 9.789f, 3.303f)
                curveTo(9.837f, 3.303f, 9.858f, 3.303f, 9.858f, 3.302f)
                curveTo(9.858f, 3.301f, 9.845f, 3.3f, 9.822f, 3.298f)
                lineTo(9.822f, 3.298f)
                curveTo(9.698f, 3.286f, 9.286f, 3.246f, 8.992f, 3.113f)
                curveTo(8.729f, 2.994f, 8.96f, 3.024f, 9.261f, 3.063f)
                curveTo(9.442f, 3.086f, 9.648f, 3.113f, 9.789f, 3.113f)
                curveTo(10.166f, 3.113f, 9.634f, 2.86f, 9.234f, 2.86f)
                curveTo(8.913f, 2.86f, 9.066f, 2.772f, 9.264f, 2.658f)
                lineTo(9.264f, 2.658f)
                curveTo(9.313f, 2.63f, 9.365f, 2.6f, 9.413f, 2.57f)
                curveTo(9.557f, 2.479f, 9.663f, 2.634f, 9.725f, 2.726f)
                curveTo(9.767f, 2.788f, 9.789f, 2.82f, 9.789f, 2.723f)
                curveTo(9.789f, 2.629f, 9.765f, 2.569f, 9.745f, 2.538f)
                curveTo(9.756f, 2.546f, 9.77f, 2.557f, 9.789f, 2.57f)
                curveTo(9.945f, 2.674f, 9.789f, 2.299f, 9.789f, 2.299f)
                curveTo(9.789f, 2.299f, 9.634f, 2.195f, 9.789f, 2.195f)
                curveTo(9.945f, 2.195f, 9.74f, 2.017f, 9.634f, 2.017f)
                curveTo(9.529f, 2.017f, 9.911f, 1.846f, 9.911f, 1.846f)
                lineTo(9.995f, 1.125f)
                curveTo(9.995f, 1.125f, 10.203f, 1.911f, 10.203f, 2.017f)
                verticalLineTo(2.57f)
                curveTo(10.203f, 2.702f, 10.11f, 2.794f, 10.047f, 2.855f)
                curveTo(9.969f, 2.932f, 9.94f, 2.962f, 10.203f, 2.962f)
                curveTo(10.676f, 2.962f, 10.656f, 3.113f, 10.368f, 3.113f)
                curveTo(10.08f, 3.113f, 10.451f, 3.303f, 10.968f, 3.303f)
                curveTo(11.485f, 3.303f, 10.534f, 3.527f, 10.203f, 3.527f)
                curveTo(9.872f, 3.527f, 10.534f, 3.63f, 10.968f, 3.63f)
                curveTo(11.26f, 3.63f, 10.96f, 3.731f, 10.683f, 3.825f)
                curveTo(10.55f, 3.87f, 10.422f, 3.913f, 10.368f, 3.942f)
                curveTo(10.282f, 3.988f, 10.494f, 3.987f, 10.718f, 3.974f)
                curveTo(10.6f, 4.009f, 10.483f, 4.045f, 10.394f, 4.072f)
                lineTo(10.394f, 4.072f)
                curveTo(10.286f, 4.105f, 10.25f, 4.116f, 10.251f, 4.121f)
                curveTo(10.251f, 4.123f, 10.261f, 4.123f, 10.277f, 4.124f)
                curveTo(10.322f, 4.127f, 10.413f, 4.132f, 10.431f, 4.191f)
                curveTo(10.458f, 4.28f, 10.705f, 4.142f, 10.938f, 4.012f)
                curveTo(10.975f, 3.991f, 11.012f, 3.97f, 11.048f, 3.951f)
                curveTo(11.109f, 3.946f, 11.148f, 3.942f, 11.148f, 3.942f)
                curveTo(11.148f, 3.942f, 11.363f, 4.189f, 11.363f, 4.34f)
                curveTo(11.363f, 4.428f, 11.081f, 4.454f, 10.78f, 4.482f)
                lineTo(10.78f, 4.482f)
                lineTo(10.75f, 4.485f)
                curveTo(10.765f, 4.465f, 10.701f, 4.475f, 10.607f, 4.498f)
                curveTo(10.451f, 4.515f, 10.304f, 4.534f, 10.203f, 4.567f)
                curveTo(10.106f, 4.599f, 10.123f, 4.612f, 10.201f, 4.614f)
                lineTo(10.18f, 4.621f)
                curveTo(10.106f, 4.643f, 10.081f, 4.651f, 10.081f, 4.656f)
                curveTo(10.082f, 4.658f, 10.089f, 4.659f, 10.1f, 4.662f)
                curveTo(10.133f, 4.668f, 10.198f, 4.681f, 10.216f, 4.74f)
                curveTo(10.243f, 4.829f, 10.408f, 4.716f, 10.564f, 4.61f)
                lineTo(10.579f, 4.6f)
                lineTo(10.727f, 4.59f)
                lineTo(10.727f, 4.59f)
                curveTo(10.896f, 4.578f, 11.059f, 4.567f, 11.148f, 4.567f)
                curveTo(11.427f, 4.567f, 10.869f, 4.702f, 10.656f, 4.702f)
                curveTo(10.565f, 4.702f, 10.679f, 4.722f, 10.854f, 4.754f)
                lineTo(10.854f, 4.754f)
                lineTo(10.854f, 4.754f)
                lineTo(10.854f, 4.754f)
                curveTo(11.09f, 4.796f, 11.435f, 4.858f, 11.532f, 4.916f)
                curveTo(11.649f, 4.985f, 11.307f, 4.959f, 11.002f, 4.936f)
                curveTo(10.863f, 4.926f, 10.732f, 4.916f, 10.656f, 4.916f)
                curveTo(10.413f, 4.916f, 10.368f, 5.114f, 10.534f, 5.114f)
                horizontalLineTo(11.148f)
                curveTo(11.381f, 5.114f, 11.623f, 5.47f, 11.532f, 5.47f)
                curveTo(11.505f, 5.47f, 11.446f, 5.488f, 11.365f, 5.514f)
                curveTo(11.177f, 5.572f, 10.867f, 5.669f, 10.534f, 5.669f)
                curveTo(10.056f, 5.669f, 11.148f, 5.67f, 11.363f, 5.669f)
                curveTo(11.577f, 5.669f, 12.188f, 5.67f, 12.188f, 5.881f)
                curveTo(12.188f, 6.013f, 12.073f, 6.041f, 11.921f, 6.079f)
                curveTo(11.829f, 6.102f, 11.723f, 6.129f, 11.623f, 6.183f)
                curveTo(11.356f, 6.328f, 12.42f, 6.459f, 12.42f, 6.459f)
                curveTo(12.42f, 6.459f, 11.999f, 6.59f, 11.794f, 6.59f)
                curveTo(11.589f, 6.59f, 11.889f, 6.784f, 12.42f, 6.784f)
                curveTo(12.83f, 6.784f, 12.71f, 7.007f, 12.634f, 7.147f)
                curveTo(12.612f, 7.187f, 12.594f, 7.221f, 12.594f, 7.24f)
                curveTo(12.594f, 7.277f, 12.516f, 7.309f, 12.404f, 7.355f)
                curveTo(12.259f, 7.414f, 12.057f, 7.496f, 11.889f, 7.643f)
                curveTo(11.696f, 7.812f, 11.931f, 7.762f, 12.196f, 7.706f)
                lineTo(12.196f, 7.706f)
                curveTo(12.341f, 7.676f, 12.495f, 7.643f, 12.594f, 7.643f)
                curveTo(12.873f, 7.643f, 12.992f, 7.655f, 12.901f, 7.79f)
                curveTo(12.81f, 7.925f, 11.999f, 8.139f, 11.794f, 8.139f)
                horizontalLineTo(12.901f)
                curveTo(13.208f, 8.139f, 12.815f, 8.382f, 12.42f, 8.382f)
                curveTo(12.155f, 8.382f, 12.007f, 8.481f, 11.909f, 8.547f)
                curveTo(11.861f, 8.579f, 11.825f, 8.603f, 11.794f, 8.603f)
                horizontalLineTo(12.594f)
                curveTo(12.635f, 8.603f, 12.679f, 8.538f, 12.72f, 8.479f)
                curveTo(12.757f, 8.426f, 12.79f, 8.378f, 12.815f, 8.382f)
                curveTo(13.177f, 8.439f, 13.014f, 8.894f, 12.815f, 8.894f)
                curveTo(12.586f, 8.894f, 11.889f, 9.048f, 11.999f, 9.203f)
                curveTo(12.052f, 9.278f, 12.135f, 9.244f, 12.269f, 9.189f)
                curveTo(12.412f, 9.13f, 12.614f, 9.048f, 12.901f, 9.048f)
                curveTo(13.456f, 9.048f, 12.954f, 9.203f, 12.815f, 9.203f)
                curveTo(12.675f, 9.203f, 12.086f, 9.315f, 11.889f, 9.412f)
                curveTo(11.758f, 9.477f, 12.215f, 9.456f, 12.668f, 9.434f)
                curveTo(12.895f, 9.423f, 13.12f, 9.412f, 13.272f, 9.412f)
                curveTo(13.729f, 9.412f, 12.188f, 9.801f, 11.623f, 9.801f)
                curveTo(11.057f, 9.801f, 11.999f, 9.951f, 12.188f, 9.951f)
                curveTo(12.261f, 9.951f, 12.402f, 9.97f, 12.576f, 9.993f)
                curveTo(12.855f, 10.031f, 13.219f, 10.08f, 13.521f, 10.08f)
                curveTo(14.01f, 10.08f, 13.032f, 10.402f, 12.594f, 10.402f)
                lineTo(12.494f, 10.402f)
                curveTo(12.103f, 10.4f, 11.81f, 10.399f, 11.999f, 10.636f)
                curveTo(12.104f, 10.767f, 12.454f, 10.731f, 12.819f, 10.694f)
                curveTo(13.165f, 10.659f, 13.526f, 10.622f, 13.704f, 10.725f)
                curveTo(14.023f, 10.911f, 12.609f, 10.895f, 11.999f, 10.888f)
                curveTo(11.912f, 10.887f, 11.841f, 10.886f, 11.794f, 10.886f)
                curveTo(11.419f, 10.886f, 12.169f, 11.026f, 12.815f, 11.026f)
                lineTo(12.896f, 11.026f)
                curveTo(13.473f, 11.025f, 13.61f, 11.025f, 13.61f, 11.215f)
                curveTo(13.61f, 11.382f, 12.353f, 11.339f, 11.829f, 11.321f)
                horizontalLineTo(11.829f)
                curveTo(11.729f, 11.317f, 11.656f, 11.315f, 11.623f, 11.315f)
                curveTo(11.522f, 11.315f, 11.464f, 11.375f, 11.404f, 11.438f)
                curveTo(11.339f, 11.505f, 11.272f, 11.575f, 11.148f, 11.575f)
                curveTo(11.047f, 11.575f, 10.999f, 11.51f, 10.955f, 11.451f)
                curveTo(10.896f, 11.37f, 10.845f, 11.301f, 10.68f, 11.415f)
                curveTo(10.392f, 11.615f, 10.968f, 13.625f, 10.968f, 13.625f)
                horizontalLineTo(9.413f)
                verticalLineTo(11.731f)
                curveTo(9.413f, 11.731f, 8.907f, 11.573f, 7.935f, 11.731f)
                close()
                moveTo(9.721f, 2.51f)
                curveTo(9.719f, 2.511f, 9.725f, 2.52f, 9.745f, 2.538f)
                curveTo(9.733f, 2.518f, 9.723f, 2.51f, 9.721f, 2.51f)
                close()
                moveTo(9.18f, 10.015f)
                curveTo(8.934f, 9.922f, 9.557f, 9.918f, 9.845f, 9.918f)
                curveTo(9.938f, 9.918f, 9.971f, 9.918f, 9.973f, 9.926f)
                curveTo(9.974f, 9.93f, 9.966f, 9.937f, 9.953f, 9.947f)
                curveTo(9.917f, 9.977f, 9.845f, 10.036f, 9.845f, 10.155f)
                curveTo(9.845f, 10.333f, 9.611f, 10.219f, 9.391f, 10.111f)
                lineTo(9.391f, 10.111f)
                curveTo(9.316f, 10.074f, 9.242f, 10.038f, 9.18f, 10.015f)
                close()
                moveTo(9.689f, 9.291f)
                curveTo(9.401f, 9.291f, 8.778f, 9.296f, 9.024f, 9.388f)
                curveTo(9.086f, 9.412f, 9.16f, 9.448f, 9.235f, 9.484f)
                lineTo(9.235f, 9.484f)
                curveTo(9.455f, 9.592f, 9.689f, 9.706f, 9.689f, 9.529f)
                curveTo(9.689f, 9.41f, 9.761f, 9.35f, 9.797f, 9.321f)
                curveTo(9.81f, 9.31f, 9.818f, 9.303f, 9.817f, 9.299f)
                curveTo(9.815f, 9.291f, 9.782f, 9.291f, 9.689f, 9.291f)
                close()
                moveTo(9.17f, 8.872f)
                curveTo(8.969f, 8.824f, 9.477f, 8.821f, 9.712f, 8.821f)
                curveTo(9.79f, 8.821f, 9.816f, 8.821f, 9.817f, 8.826f)
                curveTo(9.817f, 8.828f, 9.811f, 8.831f, 9.801f, 8.837f)
                curveTo(9.771f, 8.852f, 9.712f, 8.884f, 9.712f, 8.946f)
                curveTo(9.712f, 9.039f, 9.522f, 8.979f, 9.342f, 8.923f)
                curveTo(9.281f, 8.903f, 9.22f, 8.885f, 9.17f, 8.872f)
                close()
                moveTo(9.675f, 6.891f)
                curveTo(9.349f, 6.792f, 8.644f, 6.579f, 8.908f, 6.71f)
                curveTo(8.975f, 6.743f, 9.053f, 6.787f, 9.132f, 6.831f)
                lineTo(9.132f, 6.831f)
                lineTo(9.132f, 6.831f)
                curveTo(9.365f, 6.962f, 9.612f, 7.1f, 9.639f, 7.011f)
                curveTo(9.657f, 6.951f, 9.748f, 6.946f, 9.793f, 6.944f)
                curveTo(9.808f, 6.943f, 9.819f, 6.942f, 9.819f, 6.94f)
                curveTo(9.82f, 6.935f, 9.783f, 6.924f, 9.675f, 6.891f)
                close()
                moveTo(8.908f, 6.084f)
                curveTo(8.644f, 5.952f, 9.349f, 6.165f, 9.675f, 6.265f)
                curveTo(9.783f, 6.298f, 9.82f, 6.309f, 9.819f, 6.313f)
                curveTo(9.819f, 6.316f, 9.808f, 6.316f, 9.793f, 6.317f)
                curveTo(9.748f, 6.32f, 9.657f, 6.325f, 9.639f, 6.384f)
                curveTo(9.612f, 6.473f, 9.365f, 6.335f, 9.132f, 6.205f)
                lineTo(9.132f, 6.205f)
                lineTo(9.132f, 6.205f)
                curveTo(9.053f, 6.16f, 8.975f, 6.117f, 8.908f, 6.084f)
                close()
                moveTo(9.675f, 5.482f)
                curveTo(9.349f, 5.382f, 8.644f, 5.169f, 8.908f, 5.3f)
                curveTo(8.975f, 5.334f, 9.053f, 5.377f, 9.132f, 5.422f)
                lineTo(9.132f, 5.422f)
                lineTo(9.132f, 5.422f)
                curveTo(9.365f, 5.552f, 9.612f, 5.69f, 9.639f, 5.601f)
                curveTo(9.657f, 5.541f, 9.748f, 5.536f, 9.793f, 5.534f)
                curveTo(9.808f, 5.533f, 9.819f, 5.533f, 9.819f, 5.53f)
                curveTo(9.82f, 5.526f, 9.783f, 5.515f, 9.675f, 5.482f)
                close()
                moveTo(10.381f, 9.761f)
                curveTo(10.669f, 9.761f, 11.291f, 9.766f, 11.046f, 9.858f)
                curveTo(10.983f, 9.882f, 10.91f, 9.918f, 10.835f, 9.954f)
                lineTo(10.835f, 9.954f)
                curveTo(10.614f, 10.062f, 10.381f, 10.176f, 10.381f, 9.999f)
                curveTo(10.381f, 9.88f, 10.309f, 9.82f, 10.273f, 9.791f)
                lineTo(10.273f, 9.791f)
                curveTo(10.26f, 9.78f, 10.252f, 9.773f, 10.253f, 9.769f)
                curveTo(10.255f, 9.761f, 10.288f, 9.761f, 10.381f, 9.761f)
                close()
                moveTo(11.046f, 9.388f)
                curveTo(11.291f, 9.296f, 10.669f, 9.291f, 10.381f, 9.291f)
                curveTo(10.288f, 9.291f, 10.255f, 9.291f, 10.253f, 9.299f)
                curveTo(10.252f, 9.303f, 10.26f, 9.31f, 10.273f, 9.321f)
                lineTo(10.273f, 9.321f)
                curveTo(10.309f, 9.35f, 10.381f, 9.41f, 10.381f, 9.529f)
                curveTo(10.381f, 9.706f, 10.614f, 9.592f, 10.835f, 9.484f)
                lineTo(10.835f, 9.484f)
                curveTo(10.91f, 9.448f, 10.983f, 9.412f, 11.046f, 9.388f)
                close()
                moveTo(11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                curveTo(11.457f, 8.299f, 11.457f, 8.299f, 11.424f, 8.307f)
                curveTo(11.358f, 8.323f, 11.219f, 8.377f, 11.063f, 8.439f)
                lineTo(11.063f, 8.439f)
                curveTo(10.746f, 8.563f, 10.357f, 8.716f, 10.357f, 8.633f)
                curveTo(10.357f, 8.57f, 10.299f, 8.539f, 10.269f, 8.523f)
                curveTo(10.259f, 8.518f, 10.252f, 8.515f, 10.253f, 8.512f)
                curveTo(10.253f, 8.508f, 10.28f, 8.508f, 10.357f, 8.508f)
                curveTo(10.553f, 8.508f, 11.302f, 8.335f, 11.431f, 8.305f)
                lineTo(11.431f, 8.305f)
                close()
                moveTo(11.162f, 6.397f)
                curveTo(11.425f, 6.265f, 10.72f, 6.478f, 10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                lineTo(10.394f, 6.578f)
                curveTo(10.286f, 6.611f, 10.25f, 6.622f, 10.251f, 6.627f)
                curveTo(10.251f, 6.629f, 10.261f, 6.63f, 10.277f, 6.63f)
                curveTo(10.322f, 6.633f, 10.413f, 6.638f, 10.431f, 6.697f)
                curveTo(10.458f, 6.787f, 10.705f, 6.648f, 10.938f, 6.518f)
                lineTo(10.938f, 6.518f)
                lineTo(10.938f, 6.518f)
                curveTo(11.017f, 6.474f, 11.095f, 6.43f, 11.162f, 6.397f)
                close()
                moveTo(10.394f, 7.205f)
                curveTo(10.72f, 7.105f, 11.425f, 6.892f, 11.162f, 7.023f)
                curveTo(11.095f, 7.057f, 11.017f, 7.1f, 10.938f, 7.145f)
                lineTo(10.938f, 7.145f)
                lineTo(10.938f, 7.145f)
                curveTo(10.705f, 7.275f, 10.458f, 7.413f, 10.431f, 7.324f)
                curveTo(10.413f, 7.264f, 10.322f, 7.259f, 10.277f, 7.257f)
                curveTo(10.261f, 7.256f, 10.251f, 7.256f, 10.251f, 7.253f)
                curveTo(10.25f, 7.249f, 10.286f, 7.238f, 10.394f, 7.205f)
                lineTo(10.394f, 7.205f)
                lineTo(10.394f, 7.205f)
                lineTo(10.394f, 7.205f)
                lineTo(10.394f, 7.205f)
                lineTo(10.394f, 7.205f)
                close()
                moveTo(11.162f, 5.77f)
                curveTo(11.425f, 5.639f, 10.72f, 5.852f, 10.394f, 5.952f)
                lineTo(10.394f, 5.952f)
                lineTo(10.394f, 5.952f)
                lineTo(10.394f, 5.952f)
                lineTo(10.394f, 5.952f)
                curveTo(10.286f, 5.985f, 10.25f, 5.996f, 10.251f, 6f)
                curveTo(10.251f, 6.002f, 10.261f, 6.003f, 10.277f, 6.004f)
                curveTo(10.322f, 6.006f, 10.413f, 6.011f, 10.431f, 6.071f)
                curveTo(10.458f, 6.16f, 10.705f, 6.022f, 10.938f, 5.892f)
                lineTo(10.938f, 5.892f)
                lineTo(10.938f, 5.892f)
                curveTo(11.017f, 5.847f, 11.095f, 5.804f, 11.162f, 5.77f)
                close()
                moveTo(10.18f, 5.404f)
                curveTo(10.405f, 5.335f, 10.891f, 5.189f, 10.714f, 5.294f)
                curveTo(10.669f, 5.321f, 10.617f, 5.356f, 10.564f, 5.393f)
                curveTo(10.408f, 5.5f, 10.243f, 5.612f, 10.216f, 5.523f)
                curveTo(10.198f, 5.464f, 10.133f, 5.451f, 10.1f, 5.445f)
                curveTo(10.089f, 5.443f, 10.082f, 5.441f, 10.081f, 5.439f)
                curveTo(10.081f, 5.434f, 10.106f, 5.427f, 10.18f, 5.404f)
                lineTo(10.18f, 5.404f)
                close()
                moveTo(10.323f, 7.788f)
                curveTo(10.065f, 7.788f, 10.323f, 7.584f, 10.323f, 7.584f)
                horizontalLineTo(10.456f)
                curveTo(10.502f, 7.584f, 10.543f, 7.565f, 10.596f, 7.54f)
                curveTo(10.698f, 7.493f, 10.848f, 7.424f, 11.167f, 7.424f)
                curveTo(11.653f, 7.424f, 10.582f, 7.788f, 10.323f, 7.788f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NorfolkIslandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.NorfolkIsland,
            contentDescription = "Norfolk Island Flag"
        )
    }
}
